var styles = {
  "RichTextEditor": "_RichTextEditor_vbg4a_34",
  "Editor": "_Editor_vbg4a_38",
  "Textarea": "_Textarea_vbg4a_42",
  "PlainView": "_PlainView_vbg4a_53",
  "Textarea-readonly": "_Textarea-readonly_vbg4a_60",
  "Textarea-focused": "_Textarea-focused_vbg4a_65",
  "PlainView-hidden": "_PlainView-hidden_vbg4a_84",
  "Toolbar": "_Toolbar_vbg4a_88",
  "InlineError": "_InlineError_vbg4a_93"
};

export { styles as default };
